import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: "",
  sort: "",
  type: "All",
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    searchAction: (state, action) => {
      state.search = action.payload;
    },
    sortAction: (state, action) => {
      state.sort = action.payload;
    },
    typeAction: (state, action) => {
      state.type = action.payload;
    },
  },
});

export const { searchAction, sortAction, typeAction } = filterSlice.actions;
export default filterSlice.reducer;
